import MemberProfileContainer from 'modules/members/containers/MemberProfileContainer';

const MemberProfileView = () => <MemberProfileContainer />;

export default MemberProfileView;
